import React from 'react'
import PropTypes from 'prop-types'
import BasicFilterPopover from './BasicFilterPopover'
import BooleanFilterPopover from './BooleanFilterPopover'
import DateFilterPopover from './DateFilterPopover'
import MinMaxFilterPopover from './MinMaxFilterPopover'
import SelectFilterPopover from './SelectFilterPopover'
import MultiSelectFilterPopover from './MultiSelectFilterPopover'
import MccSelectFilterPopover from './MccSelectFilterPopover'
import AccountGroupFilterPopover from './AccountGroupFilterPopover'
import GreaterThanFilterPopover from './GreaterThanFilterPopover'
import ReferenceFilterPopover from './ReferenceFilterPopover'
import TimeInQueueFilterPopover from './TimeInQueueFilterPopover'
import AccountSegmentFilterPopover from './AccountSegmentFilterPopover'
import AnalyticFlagFilterPopover from './AnalyticFlagFilterPopover'
import VendorFilterPopover from './VendorFilterPopover'
import EmployeeFilterPopover from './EmployeeFilterPopover'

const EDITORS = {
  basic: BasicFilterPopover,
  boolean: BooleanFilterPopover,
  date: DateFilterPopover,
  min_max: MinMaxFilterPopover,
  min_max_percent: MinMaxFilterPopover,
  select: SelectFilterPopover,
  multiselect: MultiSelectFilterPopover,
  group_multiselect: AccountGroupFilterPopover,
  mcc_select: MccSelectFilterPopover,
  greater_than: GreaterThanFilterPopover,
  time_in_seconds: TimeInQueueFilterPopover,
  reference: ReferenceFilterPopover,
  // Not TableColumn filter types: the AND/OR group builder gives these to account segment,
  // vendor and employee columns and to analytics (see dashboard/filter-groups/filter-columns).
  account_segment: AccountSegmentFilterPopover,
  analytic_flag: AnalyticFlagFilterPopover,
  vendor: VendorFilterPopover,
  employee: EmployeeFilterPopover
}

export const editableFilterTypes = Object.keys(EDITORS)

// The value editor for one column's filter, chosen by its filter_type. Shared by the column
// header popovers and the AND/OR group builder; `params`/`setParams` hold that caller's state.
const FilterEditor = ({ column, options = [], dashboardId = null, referenceSearch = null, ...props }) => {
  const Editor = EDITORS[column.filter_type]
  if (!Editor) return null

  const extras = {
    select: { options },
    multiselect: { options },
    group_multiselect: { dashboardId },
    reference: {
      initialSearch: referenceSearch?.accessor_key === column.accessor_key ? referenceSearch.search_term : ''
    }
  }[column.filter_type]

  return <Editor column={column} {...props} {...extras} />
}

FilterEditor.propTypes = {
  column: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  setParams: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onSetHandleApply: PropTypes.func,
  canEdit: PropTypes.bool,
  options: PropTypes.array,
  dashboardId: PropTypes.string,
  referenceSearch: PropTypes.object
}

export default FilterEditor
